<mat-list class="grocery-list-container">
  <mat-list-item class="list-item" *ngFor="let groceryList of groceryLists$ | async">
    <a mat-line [href]="'/grocery-list/' + groceryList.id">{{groceryList.name}}</a>
  </mat-list-item>
  <mat-list-item class="list-item list-item-new" (click)="newGroceryList()">
    <i class="fa fa-plus fa-lg" aria-hidden="true"></i>
    <span>New</span>
  </mat-list-item>
</mat-list>
